/**
 * Hotel Checkout Selectors
 *
 * Memoized selectors for accessing hotel checkout state.
 */
import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store/store';

// ============================================
// Base Selectors
// ============================================

const selectHotelCheckoutState = (state: RootState) => state.hotels.checkout;

// ============================================
// Checkout Selectors
// ============================================

export const selectHotelCheckoutLoading = createSelector(
  [selectHotelCheckoutState],
  (checkout) => checkout.isLoading,
);

export const selectHotelCheckoutError = createSelector(
  [selectHotelCheckoutState],
  (checkout) => checkout.error,
);

export const selectHotelCheckoutUrl = createSelector(
  [selectHotelCheckoutState],
  (checkout) => checkout.checkoutData?.checkoutUrl ?? null,
);
